import styled from 'styled-components';

export default styled.div`
  clear: both;
  top: ${({ top }) => top};
`;
